<template lang="html">
  <v-row
    no-gutters
    style="position:relative"
  >
    <v-overlay
      :value="graphsLoading"
      color="white"
    >
      <div class="text-center ">
        <v-progress-circular
          indeterminate
          color="purple"
          :size="50"
        />
        <div class="grey--text text--darken-4 body-1 mt-3">
          Recalculating
        </div>
      </div>
    </v-overlay>

    <v-col
      cols="12"
      class="pa-0"
    >
      <v-expand-transition>
        <div
          v-if="splitAbBool"
          class="subtitle-2 pb-0"
        >
          Defined Benefit
        </div>
      </v-expand-transition>
      <FlvSplitPercent
        v-model="splitPercent"
        :total-value="Number(splitAb ? data.flv - data.ab : data.flv)"
      />
    </v-col>

    <v-expand-transition>
      <v-col
        v-if="splitAbBool"
        cols="12"
        class="pa-0"
      >
        <div class="subtitle-2 pb-0">
          Anciliary Benefit
        </div>
        <FlvSplitPercent
          v-model="splitPercentAb"
          :total-value="Number(data.ab)"
          secondary
        />
      </v-col>
    </v-expand-transition>

    <v-col
      cols="12"
      class=" no-print"
    >
      <SiInputCheckbox
        v-model="splitAbBool"
        label="Split Ancillary Benefit separately"
      />
    </v-col>

    <v-col
      cols="12"
      class="text-h6 pb-0"
      mt-4
    >
      Member spouse
    </v-col>

    <flv-values
      v-if="splitAb"
      :values="memberTotalValues"
    />
    <!-- <v-col v-if="splitAb" cols="12" class="mt-1 mb-3" ><v-divider/></v-col> -->
      

    <flv-values :values="memberValuesOne" />

    <v-col
      cols="12"
      class="py-0 pb-0"
    >
      <apexcharts
        ref="graph_member_one"
        class="no-print"
        width="100%"
        :height="250"
        :options="memberChartOneOptions"
        :series="memberSeriesOne"
      />
    </v-col>

    <flv-values :values="memberValuesTwo" />

    <v-col
      v-if="memberSeriesTwo.length > 0"
      cols="12"
      class="py-0 pb-0"
    >
      <apexcharts
        v-if="memberSeriesTwo.length > 0"
        ref="graph_member_two"
        class="no-print"
        width="100%"
        :height="250"
        :options="memberChartTwoOptions"
        :series="memberSeriesTwo"
      />
    </v-col>

    <v-col
      class="text-h6 pb-0"
      mt-4
    >
      Non-member spouse
    </v-col>

    <flv-values
      v-if="splitAb"
      :values="nonMemberTotalValues"
    />
    <!-- <v-col v-if="splitAb" cols="12" class="mt-1 mb-3" ><v-divider/></v-col> -->
    
    <flv-values :values="nonMemberValues" />
    
    <v-col
      cols="12"
      class="py-0 pb-0"
    >
      <apexcharts
        ref="graph_nonmember"
        class="no-print"
        width="100%"
        :height="250"
        :options="nonMemberChartOptions"
        :series="nonMemberSeries"
      />
    </v-col>
  </v-row>
</template>

<script>
import helpers from '@/mixins/helpers'
import VueApexCharts from 'vue-apexcharts'
import chartOptions from './chart-options'
import growthShared from './growth-shared'


export default {
  components: {
    apexcharts: VueApexCharts
  },
  mixins: [ helpers, chartOptions, growthShared ],
  props: {
    data: Object,
    tables: Object,
    // splitPercent: Number
  },
  data () {
    return {
      splitPercent: 0,
      splitPercentAb: 0,
      splitAb: false,
      splitAbBool: false,
      nonMemberSeries: [],
      memberSeriesOne: [],
      memberSeriesTwo: [],
      graphsLoading: false,
    }
  },
  computed: {
    maxFlvSv () {
      return this.splitAb 
        ? Math.max(this.data.flv, this.data.sv_nett) - this.data.ab
        : Math.max(this.data.flv, this.data.sv_nett)
    },
    labels () {
      return {
        nonMember: {
          separationAmount: 'Separation amount',
          totalBenefit: 'Total benefit',
          separationAmountAb: 'Separation amount (Ancillary Benefit)',
          separationAmountDb: 'Separation amount (Defined Benefit)',
          fundedComponent: 'Funded component of Separation Amount',
          unfundedComponent: 'Unfunded component of Separation Amount',
          fundedComponentAb: 'Funded component of Separation Amount (Defined Benefit)',
          fundedComponentDb: 'Funded component of Separation Amount (Defined Benefit)',
          unfundedComponentDb: 'Unfunded component of Separation Amount (Ancillary Benefit)',
        },
        member: {
          benefitReductionRate: 'Benefit rate of reduction',
          totalBenefitPost: 'Total benefit - post reduction',
          mb: 'Member Benefit (MB) - post reduction',
          ab: 'Ancillary Benefit (AB) - post reduction',
          eb: 'Employer Benefit (EB) - post reduction',
          feb: 'Funded employer benefit (FEB) - post reduction',
          unfunded_eb: 'Unfunded employer benefit - post reduction',
          fdb: 'Preserved funded employer benefit (FDB) - post reduction',
          udb: 'Preserved unfunded employer benefit (UDB) - post reduction',
          ebm: 'Employer benefit multiple - reduction amount',
          ebmPost: 'Employer benefit multiple - post reduction',
          abTotal: 'Ancillary Benefit (AB) element - post reduction',
          dbTotal: 'Defined Benefit element - post reduction',
        }
      }
    },
    reportType () {
      let { data: { valuation_type } } = this
      if (['msbs_contributing_under55', 'msbs_contributing_over55'].includes(valuation_type)) return 'contributor'
      if (['msbs_preserved'].includes(valuation_type)) return 'preserved'
       return null
    },
    claimTypes () {
      return [
        { text: 'Age Retirement (incl. redundancy) ', value: 'age' },
        { text: 'Invalidity', value: 'invalid' },
      ]
    },
    memberAge () {
      let { data: { relevant_date, member_birth_date } } = this
      return this._calculateAge(member_birth_date, relevant_date)
    },
    ageFactor () {
      let pensionType = this.claimType.value
      let table = this.tables.age_factors || {}
      return (table[this.claimAge] || {})[pensionType]
    },
    fundedComponent () {
      return this.splitAb 
        ? this.data.funded_component - this.data.ab
        : this.data.funded_component
    },
    nonMemberTotalValues () {
      let { _$, labels } = this
      let dbComponent = this.calcSeparationAmount()
      let abComponent = this.calculateAbReduction()
      return {
          primary: [
            { label: labels.nonMember.totalBenefit, value: _$(dbComponent + abComponent, 0) },
            { label: labels.nonMember.separationAmountAb, value: _$(abComponent, 0) }
          ],
          secondary: [
            // { label: labels.member.dbTotal, value: _$(dbComponent, 0) },
          ]
        }
    },
    nonMemberValues () {
      let { _$, labels, colors } = this
      if (this.splitAb) {
        return {
          primary: [
            { label: labels.nonMember.separationAmountDb, value: _$(this.calcSeparationAmount(), 0), color: colors[2] },

          ],
          secondary: [
            { label: labels.nonMember.fundedComponent, value: _$(this.calcFundedComponentSplit(), 0), color: colors[0] },
            { label: labels.nonMember.unfundedComponent, value: _$(this.calcUnfundedComponentSplit(), 0), color: colors[1] },
          ]
        }
        } else {
          return {
            primary: [
              { label: labels.nonMember.separationAmount, value: _$(this.calcSeparationAmount(), 0), color: colors[2] },
            ],
            secondary: [
              { label: labels.nonMember.fundedComponent, value: _$(this.calcFundedComponentSplit(), 0), color: colors[0] },
              { label: labels.nonMember.unfundedComponent, value: _$(this.calcUnfundedComponentSplit(), 0), color: colors[1] },
            ]
          }
      }
    },
    memberTotalValues () {
      let { _$, labels } = this
      let dbComponent = this.calcTotalBenefitPost()
      let abComponent = this.calculateAbPost()
      return {
          primary: [
            { label: labels.member.totalBenefitPost, value: _$(dbComponent + abComponent, 0) },
            { label: labels.member.abTotal, value: _$(abComponent, 0) }
          ],
          secondary: [
            // { label: labels.member.dbTotal, value: _$(dbComponent, 0) },
          ]
        }
    },
    memberValuesOne () {
      let { _$, labels, colors, reportType, splitAb } = this 
      let sfGross = this.calcSeparationFactorGross()
      let primary = []
      let secondary = []
      let shift = splitAb ? -1 : 0

      switch (reportType) {
        case 'contributor':
          primary = [
            { label: labels.member[this.splitAb ? 'dbTotal' : 'totalBenefitPost'], value: _$(this.calcTotalBenefitPost(sfGross), 0), color: colors[6 + shift]},
          ]
          secondary = [
            { label: labels.member.mb, value: _$(this.calcComponent('mb', sfGross), 0), color: colors[0]},
            ...( !splitAb ? [{ label: labels.member.ab, value: _$(this.calculateAbPost(sfGross), 0), color: colors[1]}] : []),
            // { label: labels.member.eb, value: _$(this.calcComponent('eb', sfGross), 0), color: colors[2 + shift]},
            { label: labels.member.feb, value: _$(this.calcComponent('feb', sfGross), 0), color: colors[2 + shift]},
            { label: labels.member.unfunded_eb, value: _$(this.calcComponent('unfunded_eb', sfGross), 0), color: colors[3 + shift]},
            { label: labels.member.fdb, value: _$(this.calcComponent('fdb_msbs', sfGross), 0), color: colors[4 + shift]},
            { label: labels.member.udb, value: _$(this.calcComponent('udb_msbs', sfGross), 0), color: colors[5 + shift]},
          ]
          break;
        case 'preserved':
          primary = [
            { label: labels.member[this.splitAb ? 'dbTotal' : 'totalBenefitPost'], value: _$(this.calcTotalBenefitPost(sfGross), 0), color: colors[4 + shift]},
          ]
          secondary = [
            { label: labels.member.mb, value: _$(this.calcComponent('mb', sfGross), 0), color: colors[0]},
            ...( !splitAb ? [{ label: labels.member.ab, value: _$(this.calculateAbPost(sfGross), 0), color: colors[1]}] : []),
            { label: labels.member.fdb, value: _$(this.calcComponent('fdb_msbs', sfGross), 0), color: colors[2 + shift]},
            { label: labels.member.udb, value: _$(this.calcComponent('udb_msbs', sfGross), 0), color: colors[3 + shift]},
          ]
          break;
        default:
      }
      return { primary, secondary }
    },
    memberValuesTwo () {
      let { labels, colors, reportType } = this 
      let sfGross = this.calcSeparationFactorGross()
      let primary = []
      let secondary = []

      switch (reportType) {
        case 'contributor':
          primary = [
            { label: labels.member.ebmPost, value: (this.calcEbmReductionPost().toFixed(8)), color: colors[0] },
          ]
          secondary = [
            { label: labels.member.ebm, value: (this.calcEbmReduction(sfGross).toFixed(8)), },
          ]
        break;
        
      }
      return { primary, secondary }
    },
    memberChartOneOptions () {
      let yFormatter = v => this._$(v, 0)
      let yMax = this.calcTotalBenefitPost(0)

      return this._chartOptions({
        ...this.sharedChartOptions,
        id: 'graph_member_one',
        stacked: true,
        yMax,
        yFormatter
      })
    },
    memberChartTwoOptions () {
      let yFormatter = v => v.toFixed(5)
      let yMax 

      return this._chartOptions({
        ...this.sharedChartOptions,
        id: 'graph_member_two',
        yFormatter,
        yMax
      })
    },
    ebm () {
      let { data: { eb, final_average_salary } } = this
      return eb / final_average_salary
    }
  },
  watch: {
    splitPercent (v) {
      if (!this.splitAb) this.splitPercentAb = v
    },
    splitAb () {
      this.$nextTick(() => {
        this.reprintGraphs()
        this.$refs.graph_member_two.updateOptions(this.memberChartTwoOptions, false, false, false)

      })
    },
    splitAbBool (v) {
      this.graphsLoading = true
      this.splitPercentAb = 0

      setTimeout(() => {
        this.splitAb = v
      }, 500)
    }
  },
  beforeMount () {
    this.graphNonMember()
    this.graphMemberOne()
  },
  mounted () {
    this.graphMemberTwo()
  },
  methods: {
    reprintGraphs () {
      this.graphNonMember()
      this.graphMemberOne()
      // this.graphMemberTwo()
    },
    graphMemberOne () {
      let { labels, reportType } = this
      let mbSeries = { name: labels.member.mb, type: 'area', data: [] }
      let abSeries = { name: labels.member.ab, type: 'area', data: [] }
      let ebSeries = { name: labels.member.eb, type: 'area', data: [] }
      let febSeries = { name: labels.member.feb, type: 'area', data: [] }
      let unfunded_ebSeries = { name: labels.member.unfunded_eb, type: 'area', data: [] }
      let fdbSeries = { name: labels.member.fdb, type: 'area', data: [] }
      let udbSeries = { name: labels.member.udb, type: 'area', data: [] }
      let totalBenefitSeries = { name: labels.member[this.splitAb ? 'dbTotal' : 'totalBenefitPost'], type: 'line', data: [] }

      this.xValues.forEach(percent => {
        let separationAmount = this.calcSeparationAmount(percent)
        let sfGross = this.calcSeparationFactorGross(separationAmount)
          

        mbSeries.data.push(this.calcComponent('mb', sfGross))
        abSeries.data.push(this.calcComponent('ab', sfGross))
        ebSeries.data.push(this.calcComponent('eb', sfGross))
        febSeries.data.push(this.calcComponent('feb', sfGross))
        unfunded_ebSeries.data.push(this.calcComponent('unfunded_eb', sfGross))
        fdbSeries.data.push(this.calcComponent('fdb_msbs', sfGross))
        udbSeries.data.push(this.calcComponent('udb_msbs', sfGross))
        totalBenefitSeries.data.push(this.calcTotalBenefitPost(sfGross))
      })

      switch (reportType) {
        case 'contributor':
          this.memberSeriesOne = [ mbSeries, ...(this.splitAb ? [] : [abSeries]), febSeries, unfunded_ebSeries, fdbSeries, udbSeries, totalBenefitSeries]
          break;
        case 'preserved':
          this.memberSeriesOne = [ mbSeries, ...(this.splitAb ? [] : [abSeries]), fdbSeries, udbSeries, totalBenefitSeries]
          break;
        default: 
          this.memberSeriesOne = []
      }
    },
    graphMemberTwo () {
      let { labels, reportType } = this
      let ebmSeries = { name: labels.member.ebmPost, type: 'line', data: [] }
   

      this.xValues.forEach(percent => {
        let separationAmount = this.calcSeparationAmount(percent)
        let sfGross = this.calcSeparationFactorGross(separationAmount)

        ebmSeries.data.push(this.calcEbmReductionPost(sfGross))
      })

      switch (reportType) {
        case 'contributor':
            this.memberSeriesTwo = [ ebmSeries ]
          break;
        default: 
          this.memberSeriesTwo = [ ]
      }
    },
    calcComponent (compId, sfGross) {
      if (sfGross === undefined) sfGross = this.calcSeparationFactorGross()
      if (compId === 'unfunded_eb') return (this.data.eb || 0) * (1 - sfGross) - this.calcComponent('feb', sfGross)
      return (this.data[compId] || 0) * (1 - sfGross)
    },
    calcEbmReduction (sfGross) {
      if (sfGross === undefined) sfGross = this.calcSeparationFactorGross()
      return this.ebm * sfGross
    },
    calcEbmReductionPost (embReduction) {
      if (embReduction === undefined) embReduction = this.calcEbmReduction()
      return this.ebm - embReduction
    },
    calculateAbReduction (sfGross) {
      if (sfGross === undefined) sfGross = this.calcSeparationFactorGross()

      return Number((this.data.ab * (this.splitPercentAb / 100)).toFixed(0))
    },
    calculateAbPost (sfGross) {
      if (sfGross === undefined) sfGross = this.calcSeparationFactorGross()

      return this.splitAb 
        ? this.data.ab - this.calculateAbReduction(sfGross)
        : this.calcComponent('ab', sfGross)
    },
    calcTotalBenefitPost (sfGross) {
      if (sfGross === undefined) sfGross = this.calcSeparationFactorGross()

      let mb = this.calcComponent('mb', sfGross)
      let ab = this.splitAb ? 0 : this.calculateAbPost(sfGross) 
      let eb = this.calcComponent('eb', sfGross)
      let feb = this.calcComponent('feb', sfGross)
      let unfunded_eb = this.calcComponent('unfunded_eb', sfGross)
      let fdb = this.calcComponent('udb_msbs', sfGross)
      let udb = this.calcComponent('fdb_msbs', sfGross)

      switch (this.reportType) {
        // case 'contributor': return mb + ab + eb + fdb + udb
        case 'contributor': return mb + ab + feb + unfunded_eb + fdb + udb
        case 'preserved': return mb + ab + eb + fdb + udb
      }
    },
    graphUpdated () {
      this.graphsLoading = false
    }
  }
}
</script>

<style lang="css">

</style>
